import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  IconButton,
  styled,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

import { ICustomTheme } from 'interfaces';

export const StyledNumberOfDeclarationsContainer = styled('div')(
  ({ theme }: { theme: ICustomTheme }) => ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.body2.fontSize,
  }),
);

export const StyledNumberOfDeclarations = styled('div')(
  ({ theme }: { theme: ICustomTheme }) => ({
    display: 'flex',
    width: 'auto',
    padding: theme.spacing(1, 2),
    paddingBottom: '10px',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.colors.white,
    backgroundColor: theme.colors.paletteFromBO.primary,
    fontWeight: 'bold',
    borderRadius: 4,
  }),
);

export const StyledDeclarationsText = styled('div')(
  ({ theme }: { theme: ICustomTheme }) => ({
    display: 'inline-block',
    whiteSpace: 'nowrap',
    padding: theme.spacing(0.5, 1),
    border: '1px solid black',
    borderLeft: 'none',
    borderRadius: '0px 4px 4px 0px',
    fontSize: theme.typography.caption.fontSize,
  }),
);

export const StyledExpandButton = styled(IconButton)(
  ({ theme }: { theme: ICustomTheme }) => ({
    [theme.breakpoints.down('sm')]: {
      marginRight: theme.spacing(1),
      background: theme.colors.grey.light5,
    },
  }),
);

export const StyledExpandLessIcon = styled(ExpandLessIcon)(
  ({ theme }: { theme: ICustomTheme }) => ({
    fontSize: theme.typography.h3.fontSize,
    color: theme.colors.grey.dark,
    [theme.breakpoints.down('sm')]: {
      color: theme.colors.paletteFromBO.main,
    },
  }),
);

export const StyledExpandMoreIcon = styled(ExpandMoreIcon)(
  ({ theme }: { theme: ICustomTheme }) => ({
    fontSize: theme.typography.h3.fontSize,
    color: theme.colors.grey.dark,
    [theme.breakpoints.down('sm')]: {
      color: theme.colors.paletteFromBO.main,
    },
  }),
);

export const StyledAccordion = styled(Accordion)(() => ({
  boxShadow: 'none',
  '&.MuiPaper-root.MuiAccordion-root::before': {
    display: 'none',
  },
  '&.MuiPaper-root.MuiAccordion-root.Mui-expanded': {
    margin: 0,
  },
}));

export const StyledAccordionSummary = styled(AccordionSummary)(() => ({
  padding: 0,
  margin: 0,
}));

export const StyledAccordionDetails = styled(AccordionDetails)(() => ({
  padding: 0,
}));
